import { render, staticRenderFns } from "./integralRecharge.vue?vue&type=template&id=c2a7274c&"
import script from "./integralRecharge.vue?vue&type=script&lang=js&"
export * from "./integralRecharge.vue?vue&type=script&lang=js&"
import style0 from "./integralRecharge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports